import { useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as UserServices from '../../../../service/admin/User/UserService';
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { makeDropdown, makeDropdownPostalCode, makeListDDL } from "../../../../util/Util";
import moment from "moment";
import { selectOption } from "../../../../component/select/SelectOption";
import axios from "axios";
import { GROLOG_URL } from "../../../../constant/apiConstant";
import { validUser } from "./validationUser";
import { t } from "i18next";

const useUserEdit = () => {
  const { token } = useSelector((state) => state.auth);

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setError] = useState()
  const [tab1, setTab1] = useState(true);
  const [tab2, setTab2] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [form, setForm] = useState({});
  const [name, setName] = useState('');
  const [listRole, setListRole] = useState([]);
  const [listDataGroup, setListDataGroup] = useState([]);
  const [listCountry, setListCountry] = useState([]);
  const [listProvince, setListProvince] = useState([]);
  const [listDistrict, setListDistrict] = useState([]);
  const [listSubDistrict, setListSubDistrict] = useState([]);
  const [listUrbanVillage, setListUrbanVillage] = useState([]);
  const [listPostalCode, setListPostalCode] = useState([]);
  const [counter, setCounter] = useState([])
  const [country, setCountry] = useState([]);
  const [island, setIsland] = useState([]);
  const [Province, setProvince] = useState([]);
  const [District, setDistrict] = useState([]);
  const [SubDistrict, setSubDistrict] = useState([]);
  const [UrbanVillage, setUrbanVillage] = useState([]);
  const [PostalCode, setPostalCode] = useState([]);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [successMessages, setSuccessMessages] = useState("");
  const [failedModalOpen, setFailedModalOpen] = useState(false);
  const [failedMessages, setFailedMessages] = useState("");

  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [pageCountry, setPageCountry] = useState(1);
  const [limitCountry, setLimitCountry] = useState(10);
  const [filter, setFilter] = useState("");
  const [pageProvince, setPageProvince] = useState(1);
  const [limitProvince, setLimitProvince] = useState(10);
  const [filterProvince, setFilterProvince] = useState("");
  const [pageDistrict, setPageDistrict] = useState(1);
  const [limitDistrict, setLimitDistrict] = useState(10);
  const [filterDistrict, setFilterDistrict] = useState("");
  const [pageSubdistrict, setPageSubdistrict] = useState(1);
  const [limitSubdistrict, setLimitSubdistrict] = useState(10);
  const [filterSubdistrict, setFilterSubdistrict] = useState("");
  const [pageUrbanvillage, setPageUrbanvillage] = useState(1);
  const [limitUrbanvillage, setLimitUrbanvillage] = useState(10);
  const [filterUrbanvillage, setFilterUrbanvillage] = useState("");
  const [pagePostalCode, setPagePostalCode] = useState(1);
  const [limitPostalCode, setLimitPostalCode] = useState(10);
  const [filterPostalCode, setFilterPostalCode] = useState("");
  const [countryId, setCountryId] = useState(null);
  const handleBack = () => {
    const prevPage = location?.state?.prevPage;

    if (prevPage.includes('detail')) {
      navigate(prevPage, { state: { id: location?.state?.id, prevPage } })
    } else {
      navigate(prevPage);
    }
  }

  const onChangeTab = (tab) => {
    switch (tab) {
      case 1:
        setTab1(true);
        setTab2(false);
        break;
      case 2:
        setTab1(false);
        setTab2(true);
        break;

      default:
        break;
    }
  }

  const getDetail = async (token, id) => {
    const res = await UserServices.detailUser(token, null, id, dispatch);
    console.log(res);
    if (res?.ok) {
      Promise.all([
        getListProvince(res?.data?.grolog_account_information?.country_id,1,100,"", false),
        getListDistrict(res?.data?.grolog_account_information?.country_id,res?.data?.grolog_account_information?.province_id,1,100,"", false),
        getListSubDistrict(res?.data?.grolog_account_information?.country_id,res?.data?.grolog_account_information?.district_id,1,100,"", false),
        getListUrbanVillage(res?.data?.grolog_account_information?.country_id, res?.data?.grolog_account_information?.sub_district_id,1,100,"", false),
        getListPostalCode(res?.data?.grolog_account_information?.urban_village_id,1,100,"", false)
      ])
      initiateData(res?.data);
      setName(res?.data?.grochat_account_information?.first_name && res?.data?.grochat_account_information?.last_name
        ? res?.data?.grochat_account_information?.first_name + " " + res?.data?.grochat_account_information?.last_name
        : res?.data?.grochat_account_information?.first_name);
    }
  }

  const initiateData = (data) => {
    setForm({
      // GroChat Account Information
      username: data?.grochat_account_information?.username,
      title: data?.grochat_account_information?.title,
      first_name: data?.grochat_account_information?.first_name,
      gender: data?.grochat_account_information?.gender,
      phone: data?.grochat_account_information?.phone,
      last_name: data?.grochat_account_information?.last_name,

      // GroLog Account Information
      email: data?.grolog_account_information?.email,
      nik: data?.grolog_account_information?.nik,
      birth_place: data?.grolog_account_information?.birth_place,
      birth_day: data?.grolog_account_information?.birth_day ? moment(new Date(data?.grolog_account_information?.birth_day)).format("YYYY-MM-DD")
        : null,
      country_id: data?.grolog_account_information?.country_id,
      province_id: data?.grolog_account_information?.province_id,
      district_id: data?.grolog_account_information?.district_id,
      sub_district_id: data?.grolog_account_information?.sub_district_id,
      urban_village_id: data?.grolog_account_information?.urban_village_id,
      address: data?.grolog_account_information?.address,
      neighbourhood: data?.grolog_account_information?.neighbourhood,
      hamlet: data?.grolog_account_information?.hamlet,
      postal_code_id: data?.grolog_account_information?.postal_code_id,
      postal_code: data?.grolog_account_information?.postal_code,

      // GroLog Access Settings
      grolog_account: data?.grolog_access_setting?.grolog_account,
      grolog_account_id: data?.grolog_access_setting?.grolog_account_id,
      role_id: data?.grolog_access_setting?.role_id,
      data_group_id: data?.grolog_access_setting?.data_group_id,
      updated_at: data?.updated_at
    });
  }

  // const getListRole = async (token, page, limit, order) => {
  //   const res = await UserServices.listRole(token, null, page, limit, order, dispatch);
  //   if (res?.ok && res.list.length > 0) {
  //     const { list } = res;
  //     setListRole(makeListDDL(list));
  //   }
  // }
  const api = GROLOG_URL
  const doGets = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "GET";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, params };
    return axios(request);
  };
  const getListRole = async (page, limit,order, filter, ids) => {
    // console.log("ids",ids);
    const currentVehicle = [...listRole];
    let roles = await doGets(
      `/role?page=${page}&limit=${limit}&order=id asc${
        filter ? `&filter= name lk ${filter}` : ""
      }`,
      token
    );
    let option = [];
    let list = roles?.data?.payload?.data;
    if (list !== null && list?.length !== undefined) {
      for (let i = 0; i < list?.length; i++) {
        const element = list[i];
        let data = {
          id: element?.id,
          value: element?.role_id,
        };
        option.push(data);
      }
      setListRole(selectOption(currentVehicle, option, "value"));
      // setLoading(false);
    } else {
      // setLoading(false);
    }
  };

  // const getListDataGroup = async (token, page, limit) => {
  //   const res = await UserServices.listDataGroup(token, null, page, limit, dispatch);
  //   if (res?.ok && res.list.length > 0) {
  //     const { list } = res;
  //     setListDataGroup(makeListDDL(list));
  //   }
  // }
  const getListDataGroup = async (page, limit,order, filter, ids) => {
    // console.log("ids",ids);
    const currentVehicle = [...listDataGroup];
    let roles = await doGets(
      `/data-group?page=${page}&limit=${limit}&order=id asc${
        filter ? `&filter= name lk ${filter}` : ""
      }`,
      token
    );
    let option = [];
    let list = roles?.data?.payload?.data;
    if (list !== null && list?.length !== undefined) {
      for (let i = 0; i < list?.length; i++) {
        const element = list[i];
        let data = {
          id: element?.id,
          value: element?.data_group_name,
        };
        option.push(data);
      }
      setListDataGroup(selectOption(currentVehicle, option, "value"));
      // setLoading(false);
    } else {
      // setLoading(false);
    }
  };

  // const getListCountry = async (token, page, limit) => {
  //   const res = await UserServices.listCountry(token, null, page, limit, dispatch)
  //   if (res?.ok && res.list.length > 0) {
  //     const { list } = res;
  //     setListCountry(makeDropdown(list));
  //   }
  // }
  
  const getListCountry = async (page, limit, filter) => {
    const currentCountry = [...listCountry];
    let countrys = await doGets(
      `/country?page=${page}&limit=${limit}${filter && `&filter=name lk ${filter}`
      }`,
      token
    );

    let option = [];
    let list = countrys?.data?.payload?.data;

    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      setListCountry(selectOption(currentCountry, option, "value"));
      setLoading(false);
      // this.setState({
      //   listUser: selectOption(currentUser, option, "value"),
      //   initiateUser: initiate,
      //   loading: false,
      // });
    } else {
      setLoading(false);
      // this.setState({ loading: false, lastPage: true });
    }
  };
const isZero=[]
  const getListProvince = async (id, page, limit, filter, isChange) => {
    const currentProvince = [...Province];
    let provinces = await doGets(
      `/province?page=${page}&limit=${limit}&filter=country_id eq ${id}${filter ? `, name lk ${filter}` : ""
      }`,
      token
    );
    let option = [];
    let list = provinces?.data?.payload?.data;
    console.log("list, list", list);
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      console.log("opt",isChange,selectOption(currentProvince, option, "value"));
      // console.log("load", loading);
      if (isChange) {
        // setLoading(!loading)
        console.log("ifff");
        // const datas = selectOption(isZero, option, "value")

        await setProvince(selectOption(isZero, option, "value"));
      } else {
        console.log("elsee dong");
        const datas= selectOption(currentProvince, option, "value")
        setCounter(datas)
        console.log("my datas",datas);
        console.log('My provinces', Province);
        
        // await setProvince([1]);
        await setProvince([...datas]) 

      }
      // setProvince([1]);
    } else {
      // setLoading(false);
    }
    // console.log("load2",loading);
    // console.log("dapet1", Province);
  };

  console.log('this is provinces',Province);

  const hasProvince = useMemo(() => {
    if (Province && (Province.length !== 0)) {
      return Province
    }
    return []
  },[Province]);

  // useEffect(() => {

  //   console.log("Province",Province);
  // },[Province, setProvince])

  const getListDistrict = async (id, idprov, page, limit, filter, isChange) => {

    const currentDistrict = [...District];
    let districts = await doGets(
      `/district?page=${page}&limit=${limit}&filter=country_id eq ${id}, province_id eq ${idprov}${filter ? `, name lk ${filter}` : ""
      }`,
      token
    );
    let option = [];
    let list = districts?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      if (isChange) {
        setDistrict(selectOption(isZero, option, "value"));
      } else {
        setDistrict(selectOption(currentDistrict, option, "value"));
      }
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const getListSubDistrict = async (id, idprov, page, limit, filter, isChange) => {
    const currentSubdistrict = [...SubDistrict];
    let districts = await doGets(
      `/sub_district?page=${page}&limit=${limit}&filter=country_id eq ${id}, district_id eq ${idprov}${filter ? `, name lk ${filter}` : ""
      }`,
      token
    );
    let option = [];
    let list = districts?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      if (isChange) {
        setSubDistrict(selectOption(isZero, option, "value"));
      } else {
        setSubDistrict(selectOption(currentSubdistrict, option, "value"));
      }
      // setSubdistrict(selectOption(currentSubdistrict, option, "value"));
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const getListUrbanVillage = async (id, idprov, page, limit, filter, isChange) => {
    const currentUrbanvillage = [...UrbanVillage];
    let districts = await doGets(
      `/urban_village?page=${page}&limit=${limit}&filter=country_id eq ${id}, sub_district_id eq ${idprov}${filter ? `, name lk ${filter}` : ""
      }`,
      token
    );
    let option = [];
    let list = districts?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      if (isChange) {
        setUrbanVillage(selectOption(isZero, option, "value"));
      } else {
        setUrbanVillage(selectOption(currentUrbanvillage, option, "value"));
      }
      // setUrbanvillage(selectOption(currentUrbanvillage, option, "value"));
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const getListPostalCode = async (idUrbanVillage, page, limit, filter, isChange) => {
    const currentPostalCode = [...PostalCode];
    let postal_code = await doGets(
      `/postal_code?page=${page}&limit=${limit}&filter=urban_village_id eq ${idUrbanVillage}${filter ? `, name lk ${filter}` : ""
      }`,
      token
    );
    let option = [];
    let list = postal_code?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.code,
        };
        option.push(data);
      }
      if (isChange) {
        setPostalCode(selectOption(isZero, option, "value"));
      } else {
        setPostalCode(selectOption(currentPostalCode, option, "value"));
      }
      // setUrbanvillage(selectOption(currentUrbanvillage, option, "value"));
      setLoading(false);
    } else {
      setLoading(false);
    }
  };


  const onScrollCountry = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
      target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);

      setPageCountry(pageCountry + 1);
      target.scrollTo(0, target.scrollHeight);
      getListCountry(pageCountry, limitCountry);
      // setTimeout(() => {
      //   getListCountry(pageCountry,limitCountry)
      // }, 256);
    }
  };

  const onChangeCountry = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setListCountry([]);
      setPageCountry(resetPage);
      // this.setState(
      setTimeout(() => {
        getListCountry(pageCountry, limitCountry, filter,true);
      }, 256);
    } else if (!value) {
      setLoading(true);
      setListCountry([]);
      setFilter(resetFilter);
      setPageCountry(resetPage);
      getListCountry(pageCountry, limitCountry, filter);
    }
  };
  const onScrollProvince = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
      target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      console.log("sini g");
      setPageProvince(pageProvince + 1);
      target.scrollTo(0, target.scrollHeight);
      getListProvince(form?.country_id, pageProvince, limitProvince, "");
      // setTimeout(() => {
      //   getListProvince(pageProvince,limitProvince)
      // }, 256);
    }
  };

  const onChangeProvince = async(event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    
    setProvince([]);
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    // setProvince([]);
    if (value.length >= 2) {
      setProvince([]);
      setPageProvince(resetPage);
      // this.setState(
      // setTimeout(async() => {
        await getListProvince(form?.country_id, resetPage, limitProvince, filter,true);
      // }, 256);
    } else if (!value) {
      setLoading(true);
      setProvince([]);
      setFilter(resetFilter);
      setPageProvince(resetPage);
      await getListProvince(form?.country_id, resetPage, limitProvince, filter);
    }
  };
console.log("Province", District);
  const onScrollDistrict = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
      target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      console.log("sini g");
      setPageDistrict(pageDistrict + 1);
      target.scrollTo(0, target.scrollHeight);
      getListDistrict(
        form?.country_id,
        form?.province_id,
        pageDistrict,
        limitDistrict,
        ""
      );
      // setTimeout(() => {
      //   getListDistrict(pageDistrict,limitDistrict)
      // }, 256);
    }
  };

  const onChangeDistrict = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setDistrict([]);
      setPageDistrict(resetPage);
      // this.setState(
      setTimeout(() => {
        getListDistrict(
          form?.country_id,
          form?.province_id,
          pageDistrict,
          limitDistrict,
          filter,
          true
        );
      }, 256);
    } else if (!value) {
      setLoading(true);
      setDistrict([]);
      setFilter(resetFilter);
      setPageDistrict(resetPage);
      getListDistrict(
        form?.country_id,
        form?.province_id,
        pageDistrict,
        limitDistrict,
        filter
      );
    }
  };
  const onScrollSubdistrict = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
      target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      console.log("sini g");
      setPageSubdistrict(pageSubdistrict + 1);
      target.scrollTo(0, target.scrollHeight);
      getListSubDistrict(
        form?.country_id,
        form?.district_id,
        pageSubdistrict,
        limitSubdistrict,
        ""
      );
      // setTimeout(() => {
      //   getListSubdistrict(pageSubdistrict,limitSubdistrict)
      // }, 256);
    }
  };

  const onChangeSubdistrict = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setSubDistrict([]);
      setPageSubdistrict(resetPage);
      // this.setState(
      setTimeout(() => {
        getListSubDistrict(
          form?.country_id,
          form?.district_id,
          pageSubdistrict,
          limitSubdistrict,
          filter,
          true
        );
      }, 256);
    } else if (!value) {
      setLoading(true);
      setSubDistrict([]);
      setFilter(resetFilter);
      setPageSubdistrict(resetPage);
      getListSubDistrict(
        form?.country_id,
        form?.district_id,
        pageSubdistrict,
        limitSubdistrict,
        filter
      );
    }
  };
  const onScrollUrbanvillage = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
      target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      console.log("sini g");
      setPageUrbanvillage(pageUrbanvillage + 1);
      target.scrollTo(0, target.scrollHeight);
      getListUrbanVillage(
        form?.country_id,
        form?.sub_district_id,
        pageUrbanvillage,
        limitUrbanvillage,
        ""
      );
      // setTimeout(() => {
      //   getListUrbanvillage(pageUrbanvillage,limitUrbanvillage)
      // }, 256);
    }
  };

  const onScrollPostalCode = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
      target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      setPagePostalCode(pagePostalCode + 1);
      target.scrollTo(0, target.scrollHeight);
      getListPostalCode(
        form?.urban_village_id,
        pagePostalCode,
        limitPostalCode,
        ""
      );
      // setTimeout(() => {
      //   getListUrbanvillage(pageUrbanvillage,limitUrbanvillage)
      // }, 256);
    }
  };

  const onChangeUrbanvillage = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setUrbanVillage([]);
      setPageUrbanvillage(resetPage);
      // this.setState(
      setTimeout(() => {
        getListUrbanVillage(
          form?.country_id,
          form?.sub_district_id,
          pageUrbanvillage,
          limitUrbanvillage,
          filter,
          true
        );
      }, 256);
    } else if (!value) {
      setLoading(true);
      setUrbanVillage([]);
      setFilter(resetFilter);
      setPageUrbanvillage(resetPage);
      getListUrbanVillage(
        form?.country_id_id,
        form?.sub_district_id,
        pageUrbanvillage,
        limitUrbanvillage,
        filter
      );
    }
  };

  const onChangePostalCode = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setPostalCode([]);
      setPagePostalCode(resetPage);
      // this.setState(
      setTimeout(() => {
        getListPostalCode(
          form?.urban_village_id,
          pagePostalCode,
          limitPostalCode,
          filter
        );
      }, 256);
    } else if (!value) {
      setLoading(true);
      setPostalCode([]);
      setFilter(resetFilter);
      setPagePostalCode(resetPage);
      getListPostalCode(
        form?.urban_village_id,
        pagePostalCode,
        limitPostalCode,
        filter
      );
    }
  };

  useEffect(() => {
    getDetail(token, location?.state?.id);
  }, [])

  useEffect(() => {
    // const fetchData = async () => {
    //   // await getDetail(token, location?.state?.id);

    // }
    // fetchData();

    getListRole(page, limit, `updated_at asc`);
    getListDataGroup(page, limit, `updated_at asc`);
    getListCountry(page, limit);

    // eslint-disable-next-line
  }, [page, limit, filterProvince, filterDistrict]);

  // useEffect(() => {
  //   if (form?.country_id !== undefined) {
  //     setFilterProvince(`country_id eq ${form?.country_id}`);
  //     getListProvince(token, page, limit, `country_id eq ${form?.country_id}`);
  //     getListSubDistrict(token, page, limit, `country_id eq ${form?.country_id}`);
  //     getListUrbanVillage(token, page, limit, `country_id eq ${form?.country_id}`);
  //   }
  //   if (form?.country_id !== undefined && form?.province_id !== undefined) {
  //     setFilterDistrict(`country_id eq ${form?.country_id}, province_id eq ${form?.province_id}`);
  //     getListDistrict(token, page, limit, `country_id eq ${form?.country_id}, province_id eq ${form?.province_id}`);
  //   }
  //   if (form?.urban_village_id !== undefined) {
  //     setFilterPostalCode(`urban_village_id eq ${form?.urban_village_id}`)
  //     getListPostalCode(token, page, limit, `urban_village_id eq ${form?.urban_village_id}`);
  //   }

  // }, [form?.country_id, form?.province_id, form?.urban_village_id]);

  const _onChange = (evt, namespace) => {
    if (namespace === 'birth_day') {
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [namespace]: moment(new Date(evt)).format("YYYY-MM-DD")
        };
      });
    } else {
      let eror = validUser(namespace, evt.target.value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [namespace]: evt.target.value
        };
      });
    }

  }

  const _onChangeSelect = (evt, namespace) => {
    const isChange=true
    let eror = validUser(namespace, evt, t);
    setError({ ...error, ...eror });
    if (namespace === "country_id") {
      // setForm((prevsValue) => {
      //   return {
      //     ...prevsValue,
      //     [namespace]: evt,
      //     province_id: null,
      //     district_id: null,
      //     sub_district_id: null,
      //     urban_village_id: null,
      //     postal_code_id: null
      //   };
      // });
      setIsland([])
      setProvince([])
      setDistrict([])
      setSubDistrict([])
      setUrbanVillage([])
      setPostalCode([])
      setSearchValue("")
      setFilter("")
      getListProvince(evt,1,10,"",isChange);
      // let eror = validDriver("country_id", evt, t);
      // setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          ["country_id"]: evt,
          ["island_id"]:"",
          ["province_id"]:"",
          ["district_id"]:"",
          ["sub_district_id"]:"",
          ["urban_village_id"]:"",
          ["postal_code_id"]:"",
        };
      });
    }else if (namespace === "province_id") {
      setDistrict([])
      setSubDistrict([])
      setUrbanVillage([])
      setPostalCode([])
      getListDistrict(form.country_id, evt,1,10,"",isChange);
      setSearchValue("")
      setFilter("")
      // let eror = validDriver("province_id", evt, t);
      // setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          ["province_id"]: evt,
          ["district_id"]:"",
          ["sub_district_id"]:"",
          ["urban_village_id"]:"",
          ["postal_code_id"]:"",
        };
      });
    }else if (namespace === "district_id") {
      setSubDistrict([])
      setUrbanVillage([])
      setPostalCode([])
      getListSubDistrict(form.country_id, evt,1,10,"",isChange);
      setSearchValue("")
      setFilter("")
      // let eror = validDriver("province_id", evt, t);
      // setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          ["district_id"]:evt,
          ["sub_district_id"]:"",
          ["urban_village_id"]:"",
          ["postal_code_id"]:"",
        };
      });
    }else if (namespace === "sub_district_id") {
      setUrbanVillage([])
      setPostalCode([])
      getListUrbanVillage(form.country_id, evt,1,10,"",isChange);
      setSearchValue("")
      setFilter("")
      // let eror = validDriver("province_id", evt, t);
      // setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          ["sub_district_id"]:evt,
          ["urban_village_id"]:"",
          ["postal_code_id"]:"",
        };
      });
    }else if (namespace === "urban_village_id") {
      setPostalCode([])
      getListPostalCode(evt,1,10,"",isChange);
      setSearchValue("")
      setFilter("")
      // let eror = validDriver("province_id", evt, t);
      // setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          ["urban_village_id"]:evt,
          ["postal_code_id"]:"",
        };
      });
    }else if (namespace === "postal_code_id") {
      setSearchValue("")
      setFilter("")
      // let eror = validDriver("province_id", evt, t);
      // setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          ["postal_code_id"]:evt,
        };
      });
    } else {
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [namespace]: evt
        };
      });
    }
  }

  const validateSubmit = (error) => {
    for (const key in error) {
      if (Object.hasOwnProperty.call(error, key)) {
        if (error[key]) return false;
      }
    }
    return true;
  };
  const _onSave = async () => {
    const data = {
      email: form.email,
      nik: form.nik,
      birth_place: form.birth_place,
      birth_day: form.birth_day,
      country_id: form.country_id ? form.country_id : 0,
      province_id: form.province_id ? form.province_id :0,
      district_id: form.district_id ? form.district_id : 0,
      sub_district_id: form.sub_district_id ? form.sub_district_id :0,
      urban_village_id: form.urban_village_id ? form.urban_village_id :0,
      address: form.address,
      neighbourhood: form.neighbourhood,
      hamlet: form.hamlet,
      postal_code_id: form.postal_code_id ? form.postal_code_id : 0,
      role_id: form.role_id,
      data_group_id: form.data_group_id,
      access_setting: [
        {
          grolog_account_id: form.grolog_account_id,
          role_id: form.role_id,
          data_group_id: form.data_group_id,
          action: 3
        }
      ],
      updated_at: form.updated_at
    }
    
    let errors={}
    for (const key in data) {
      const option = validUser(key, data[key], t)
      // let option = validUserProfile(key, value[key], this.props.t);
      const currentError = option;
      errors = { ...currentError, ...errors };
    }

    setError(errors);
    if (validateSubmit(errors)) {
      try{
    const { success, message } = await UserServices.updateUser(token, data, location?.state?.id, dispatch);
    if (success) {
      setSuccessModalOpen(true)
      setSuccessMessages(message)
    } else {
      setFailedModalOpen(true);
      setFailedMessages(message);
    }
  } catch(err){

  }
  }
  }

  const _onOk = () => {
    setSuccessModalOpen(false);
    handleBack();
  }

  return {
    handleBack,
    tab1,
    tab2,
    setTab1,
    setTab2,  
    onChangeTab,
    form,
    name,
    listRole,
    listDataGroup,
    listCountry,
    listProvince,
    District,
    SubDistrict,
    UrbanVillage,
    PostalCode,
    Province,
    _onChange,
    _onSave,
    _onChangeSelect,
    successModalOpen,
    failedModalOpen,
    _onOk,
    failedMessages,
    setFailedModalOpen,
    onChangeCountry,
    onChangeDistrict,
    onChangePostalCode,
    onChangeProvince,
    onChangeSubdistrict,
    onChangeUrbanvillage,
    onScrollCountry,
    onScrollDistrict,
    onScrollPostalCode,
    onScrollProvince,
    onScrollUrbanvillage,
    onScrollSubdistrict,
    loading,
    searchValue,
    error
  }
}

export default useUserEdit;